import { useState } from 'react'
import styled from 'styled-components'
import { useProduct } from '../../_methods'
import Top from './Top'
import Bottom from './Bottom'
import Carousel from './Carousel'
import {
  ProductViewImageFragment,
  ImageThumbnail64Fragment,
} from 'api/operations'
import breakpoints from 'utils/consts/breakpoints'

const Wrapper = styled.div`
  grid-area: images;
  display: flex;
  flex-direction: column;
  row-gap: 12px;
  position: relative;
  height: 648px;

  @media screen and ${breakpoints.device.tablet} {
    max-width: calc(100vw - 48px);
    margin-bottom: 24px;
    height: 480px;
  }

  @media screen and ${breakpoints.device.mobile} {
    max-width: calc(100vw - 32px);
    margin-bottom: 24px;
    height: 400px;
  }
`
const Images = () => {
  const product = useProduct()

  const images = [
    product?.bottleImage,
    product?.frontLabelImage,
    product?.backLabelImage,
  ].filter(Boolean) as ProductViewImageFragment[]

  const thumbs = [
    product?.bottleImageThumb,
    product?.frontLabelImageThumb,
    product?.backLabelImageThumb,
  ].filter(Boolean) as ImageThumbnail64Fragment[]

  const [selectedImage, setSelectedImage] = useState(0)

  return (
    <Wrapper>
      <Top product={product} />

      <Carousel images={images} selectedImage={selectedImage} />

      <Bottom
        images={thumbs}
        product={product}
        selectedImage={selectedImage}
        setSelectedImage={setSelectedImage}
      />
    </Wrapper>
  )
}

export default Images
